import { IZoomPlugin, ZoomRange } from '@/shared/Charting/LineChart/lineChart.types.ts'
import LineChart from '@/shared/Charting/LineChart'

const ZoomPlugin: () => IZoomPlugin = () => ({
  chart: null,
  limits: { xMin: Number.MIN_SAFE_INTEGER, xMax: Number.MAX_SAFE_INTEGER, maxDelta: Number.MAX_SAFE_INTEGER },
  init(chart: LineChart) {
    this.chart = chart
  },
  setLimits(limits) {
    this.limits = { ...this.limits, ...limits }
  },
  onWheel(e) {
    // e.deltaY is always zero if shiftKey is pressed
    if (e.shiftKey) return

    e.preventDefault()

    const factor = e.deltaY > 0 ? 1.1 : 0.9
    const zoom = this.chart.zoom
    const centerX = (zoom.xMin + zoom.xMax) / 2
    const centerY = (zoom.yMin + zoom.yMax) / 2

    const rangeX = (zoom.xMax - zoom.xMin) * factor
    const rangeY = (zoom.yMax - zoom.yMin) * factor

    const newZoomConfig: ZoomRange = {
      xMin: e.ctrlKey ? this.chart.zoom.xMin : Math.max(centerX - rangeX / 2, this.limits.xMin),
      xMax: e.ctrlKey ? this.chart.zoom.xMax : Math.min(centerX + rangeX / 2, this.limits.xMax),
      yMin: centerY - rangeY / 2,
      yMax: centerY + rangeY / 2,
    }

    if (Math.abs(newZoomConfig.xMax - newZoomConfig.xMin) < this.limits.maxDelta) {
      this.chart.zoom.setZoom(newZoomConfig, 'zoom-plugin')
    }

    this.chart.render()
  },
})

export default ZoomPlugin
